import { s1 } from "../assets";
import { useEffect, useRef } from "react";
import styles from "../style";
import "../index.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import Lenis from "lenis";
import { Link } from "react-router-dom";
import ProductList from "../pages/components/ProductList";
import Products from "../pages/Products";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, SplitText);

const PortfolioScroll = () => {
  const heroRef = useRef(null);
  const heroHeaderRef = useRef(null);
  const heroCopyRef = useRef(null);
  const heroImgRef = useRef(null);
  const aboutRef = useRef(null);
  const aboutImgsCol1Ref = useRef(null);
  const aboutImgsCol2Ref = useRef(null);
  const aboutImgsCol3Ref = useRef(null);
  const aboutImgsCol4Ref = useRef(null);

  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);

    // Split text animation
    const heroCopySplit = SplitText.create(".hero-copy h3", {
      type: "words",
      wordsClass: "word",
    });

    let isHeroCopyHidden = false;

    // Main scroll trigger for hero section
    ScrollTrigger.create({
      trigger: ".hero",
      start: "top top",
      end: `+${window.innerHeight * 3.5}px`,
      pin: true,
      pinSpacing: false,
      scrub: 1,
      onUpdate: (self) => {
        const progress = self.progress;

        // Hero header animation
        const heroHeaderProgress = Math.min(progress / 0.29, 1);
        gsap.set(".hero-header", { yPercent: -heroHeaderProgress * 100 });

        // Hero words animation
        const heroWordsProgress = Math.max(0, Math.min((progress - 0.29) / 0.29, 1));
        const totalWords = heroCopySplit.words.length;
        heroCopySplit.words.forEach((word, i) => {
          const wordStart = i / totalWords;
          const wordEnd = (i + 1) / totalWords;
          const wordOpacity = Math.max(0, Math.min((heroWordsProgress - wordStart) / (wordEnd - wordStart), 1));
          gsap.set(word, { opacity: wordOpacity });
        });

        // Hero copy visibility
        if (progress > 0.64 && !isHeroCopyHidden) {
          isHeroCopyHidden = true;
          gsap.to(".hero-copy h3", { opacity: 0, duration: 0.2 });      
        } else if (progress <= 0.64 && isHeroCopyHidden) {
          isHeroCopyHidden = false;
          gsap.to(".hero-copy h3", { opacity: 1, duration: 0.2 });       
        }

        // Hero image animation
        const heroImgProgress = Math.max(0, Math.min((progress - 0.65) / 0.29, 1));
        const heroImgWidth = gsap.utils.interpolate(window.innerWidth, 345, heroImgProgress);
        const heroImgHeight = gsap.utils.interpolate(window.innerHeight, 200, heroImgProgress);
        const heroImgBorderRadius = gsap.utils.interpolate(0, 10, heroImgProgress);
        gsap.set(".hero-img", {
          width: heroImgWidth,
          height: heroImgHeight,
          borderRadius: heroImgBorderRadius
        });
      }
    });

    // About section image columns animation
    const aboutImgCols = [
      { ref: aboutImgsCol1Ref.current, y: -500 },
      { ref: aboutImgsCol2Ref.current, y: -250 },
      { ref: aboutImgsCol3Ref.current, y: -250 },
      { ref: aboutImgsCol4Ref.current, y: -500 },
    ];
    
    aboutImgCols.forEach(({ ref, y }) => {
      if (ref) {
        gsap.to(ref, {
          y,
          scrollTrigger: {
            trigger: ".about",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          } 
        });
      }
    });

    // Cleanup
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      lenis.destroy();
      gsap.ticker.remove((time) => lenis.raf(time * 1000));
    };
  }, []);

  return ( 
    <div className={`w-full`}>
      <section className={`hero`} ref={heroRef}>
        <div className={`hero-img`} ref={heroImgRef}>
          <img src={s1} alt="" />
        </div>

        <div className={`hero-header`} ref={heroHeaderRef}>
          <h1 className="my-4 xs:text-xl text-lg font-semibold">
            Help build the future of Africa!
          </h1>
        </div>

        <div className="hero-copy" ref={heroCopyRef}>
          <h3 className="my-4 xs:text-lg text-md font-semibold mr-10">
            Our firm belief in the Promise of Africa drives our mission to resource, cultivate and elevate the next generation of disruptive, tech-driven startups owned and led by visionary African entrepreneurs.
          </h3>
        </div>
      </section>

      <section className={`about`} ref={aboutRef}>
        <div className={`about-images`}>
          
          <div className="about-header flex flex-col gap-2 items-center">
            <h3 className="pt-20 mb-4 text-center xs:text-sm text-ss font-semibold leading-[21.58px] max-w-[480px]">AfriNext Ventures</h3>
            <h3 className="my-4 text-center xs:text-sm text-ss font-semibold leading-[21.58px] max-w-[480px]">
              We believe in the authenticity of the African heritage; The promise of Africa and accelerating Africa’s value among the next generation of disruptors.
            </h3> 
            <Link to="" onClick={() => window.scrollTo(0, 0)}>           
              <p className={`font-bold text-md text-second`}>Our Portfolio</p>
            </Link>
            <Products />
          </div>
        </div>
      </section>
       
    </div>
  )
};

export default PortfolioScroll;

/**
 * <div className="about-imgs-col" id="about-imgs-col-1" ref={aboutImgsCol1Ref}>
            <div className="img">
              <img src={c1} alt="About 1" />
            </div>
            <div className="img">
              <img src={LukuFiti} alt="About 2" />
            </div>
            <div className="img">
              <img src={Rembeka} alt="About 3" />
            </div>
            <div className="img">
              <img src={goSoft} alt="About 4" />
            </div>          
          </div>
          <div className="about-imgs-col" id="about-imgs-col-2" ref={aboutImgsCol2Ref}>
            <div className="img">
              <img src={f1} alt="About 5" />
            </div>
            <div className="img">
              <img src={SafiriSalama} alt="About 6" />
            </div>
            <div className="img">
              <img src={f1} alt="About 7" />
            </div>
            <div className="img">
              <img src={c1} alt="About 8" />
            </div>          
          </div>
          <div className="about-imgs-col" id="about-imgs-col-3" ref={aboutImgsCol3Ref}>
            <div className="img">
              <img src={LukuFiti} alt="About 9" />
            </div>
            <div className="img">
              <img src={goSoft} alt="About 10" />
            </div>
            <div className="img">
              <img src={Rembeka} alt="About 11" />
            </div>
            <div className="img">
              <img src={SafiriSalama} alt="About 12" />
            </div>          
          </div>
          <div className="about-imgs-col" id="about-imgs-col-4" ref={aboutImgsCol4Ref}>
            <div className="img">
              <img src={c1} alt="About 13" />
            </div>
            <div className="img">
              <img src={f1} alt="About 14" />
            </div>
            <div className="img">
              <img src={SafiriSalama} alt="About 15" />
            </div>
            <div className="img">
              <img src={LukuFiti} alt="About 16" />
            </div>          
          </div>
*/